<script lang="ts" setup>
import { AppRadioButtons } from '@libs/ui';

import { FilterType, FilterUpdateEventType } from '../../Filters.model';

import type {
  RadioButtonFilterData,
  RadioButtonUpdateFilterEvent,
} from './RadioButtonFilter.model';

interface FlightsFiltersProps {
  data: RadioButtonFilterData;
}

const props = defineProps<FlightsFiltersProps>();

interface RadioButtonFilterEmits {
  (eventName: 'update', context: RadioButtonUpdateFilterEvent): void;
}

const emit = defineEmits<RadioButtonFilterEmits>();

function update(value: number | undefined): void {
  emit('update', {
    eventType: FilterUpdateEventType.UpdateFilter,
    filterType: FilterType.RadioButton,
    selected: value,
    ingredientId: props.data.ingredientId,
  });
}
</script>

<template>
  <div class="radio-button-filter">
    <p v-if="props.data.title" class="title">{{ props.data.title }}</p>
    <AppRadioButtons
      :items="props.data.options"
      :item-value="props.data.selected"
      :theme="props.data.theme"
      @toggle-selected="update"
    />
  </div>
</template>

<style scoped lang="scss">
.radio-button-filter {
  .title {
    @include font-label-l-light;
  }
}
</style>
